module.exports = __webpack_public_path__ + "img/8439540.cfca4299.png";